import React from 'react';
import ReactDOM from 'react-dom';
import Root from './app/components/Root/Root';
import 'react-toastify/dist/ReactToastify.css';
import 'react-day-picker/lib/style.css';
import './index.scss';
import './i18n';
// import { datadogRum } from '@datadog/browser-rum';

// if (process.env.NODE_ENV !== 'development') {
//     datadogRum.init({
//         applicationId: 'd16de4ea-1c11-4614-9800-7c3e8b793164',
//         clientToken: 'pub0c936703bf2e55a8fb6279b5bd0188dd',
//         site: 'datadoghq.com',
//         service:'mavigps-web-admin',
//         // Specify a version number to identify the deployed version of your application in Datadog 
//         // version: '1.0.0',
//         sampleRate: 100,
//         replaySampleRate: 100,
//         trackInteractions: true,
//         defaultPrivacyLevel:'mask-user-input',
//     });
        
//     datadogRum.startSessionReplayRecording();
// }

ReactDOM.render(<Root />, document.getElementById('root'));

